import {
  Zap,
  Database,
  Lock,
  BarChart3,
  Award,
  Shield,
  LucideIcon
} from 'lucide-react';

/**
 * Maps icon names to their corresponding Lucide React icon components
 * Used for dynamically rendering icons from feature card data
 */
export const iconMap: Record<string, LucideIcon> = {
  Zap,
  Database,
  Lock,
  BarChart3,
  Award,
  Shield
};

/**
 * Gets the icon component for a given icon name
 * Returns Shield icon as fallback if icon name is not found
 * @param iconName - Name of the icon (e.g., 'Zap', 'Database')
 * @returns Lucide React icon component
 */
export const getIcon = (iconName: string): LucideIcon => {
  return iconMap[iconName] || Shield;
};
